/**
 * View component for /admin/authoring/sites/:siteId/update
 *
 * Updates a single site from a copy of the selcted site
 * as defined in the site reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { history, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as siteActions from '../siteActions';
import * as siteLocationActions from '../../siteLocation/siteLocationActions';
import * as sponsorActions from '../../sponsor/sponsorActions';
import * as studyActions from '../../study/studyActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";
import Breadcrumbs from '../../../global/components/routing/Breadcrumbs.js.jsx';

// import module components
import SiteForm from '../components/SiteForm.js.jsx';

// import site css modules
import siteStyles from '../siteModuleStyles.css';

class AdminUpdateSite extends Base {
  constructor(props) {
    super(props);
    const { selectedSite, siteMap } = this.props;
    this.state = {
      site: siteMap[selectedSite.id] ? _.cloneDeep(siteMap[selectedSite.id]) : {}
      // NOTE: we don't want to change the store, just make changes to a copy
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
    );
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(siteActions.fetchSingleIfNeeded(match.params.siteId)).then((json) => {
      dispatch(studyActions.fetchListIfNeeded("_organization", json.item._organization));
    });
    dispatch(sponsorActions.fetchListIfNeeded('all'));
    dispatch(siteLocationActions.fetchListIfNeeded("all"));
  }

  componentWillReceiveProps(nextProps) {
    const { selectedSite, siteMap } = nextProps;
    this.setState({
      site: siteMap[selectedSite.id] ? _.cloneDeep(siteMap[selectedSite.id]) : {}
      //we don't want to actually change the store's site, just use a copy
    })
  }

  _handleFormChange(e) {
    const { dispatch } = this.props;
    let newSiteState = _.update( this.state.site, e.target.name, function() {
      return e.target.value;
    });
    this.setState({site: newSiteState});
    if(e.target.name === "_organization") {
      dispatch(studyActions.fetchListIfNeeded("_organization", e.target.value));
    }
  }

  _handleFormSubmit(e) {
    const { dispatch, history, match } = this.props;
    e.preventDefault();
    dispatch(siteActions.sendUpdateSite(this.state.site)).then((action) => {
      if(action.success) {
        history.push(`${match.url.replace('/update-site', '')}`);
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert(`ERROR: ${action.error}`);
      }
    });
  }

  render() {
    const {
      location
      , match
      , selectedSite
      , siteLocationStore
      , siteMap
      , sponsorStore
      , studyStore
    } = this.props;
    const { site } = this.state;
    const siteLocations = siteLocationStore.util.getList() || [];
    const sponsors = sponsorStore.util.getList() || [];
    const studies = studyStore.util.getList("_organization", site._organization) || [];
    const isEmpty = (!site || site._id === null || site._id === undefined);
    return  (
      <div className="flex">
         <Helmet
          title={"Update Site | Pro-ficiency"}
        />
        <section className="section">
          <div className="yt-container">
            <Breadcrumbs links={location.state.breadcrumbs} />
          </div>
          { isEmpty ?
            (selectedSite.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
            :
            <SiteForm
              cancelLink={`${match.url.replace('/update-site','')}`}
              formTitle="Update Site"
              formType="update"
              fromStudy={this.props.match.params.studyId ? true : false }
              handleFormChange={this._handleFormChange}
              handleFormSubmit={this._handleFormSubmit}
              site={site}
              siteLocations={siteLocations}
              sponsors={sponsors}
              studies={studies}
              />
          }
        </section>
      </div>
    )
  }
}

AdminUpdateSite.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    selectedSite: store.site.selected
    , siteMap: store.site.byId
    , siteLocationStore: store.siteLocation
    , sponsorStore: store.sponsor
    , studyStore: store.study
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(AdminUpdateSite)
);



// WEBPACK FOOTER //
// modules/site/views/AdminUpdateSite.js.jsx